import { useCurrentWorkspace } from '@gripp/shared-logic';
import { RoutineExecutionProps, RoutineModules } from '@gripp/shared-ui';
import { useState } from 'react';
import { useWindowDimensions } from '../../shared/hooks/useWindowDimensions';
import { RoutineFold } from './routineFold';
import { RoutinePreviewModal } from './routinePreviewModal';

export const Routines = () => {
  const windowDimensions = useWindowDimensions();
  const maxHeight = (windowDimensions?.height ?? 0) - 185; // substract banner + padding height

  const [openRoutinePreviewModal, setOpenRoutinePreviewModal] = useState(false);
  const [executeModalProps, setExecuteModalProps] = useState<
    RoutineExecutionProps | undefined
  >();
  const currentWorkspace = useCurrentWorkspace();
  const onRoutineSelected = (row: any) => {
    const {
      assetsCount,
      allAssetsCount,
      submissionsCount,
      lastSubmitted,
      updatedAt,
      ...rest
    } = row || {};

    setOpenRoutinePreviewModal(true);
    setExecuteModalProps({
      workspaceAsset: {
        workspace: currentWorkspace,
      },
      module: RoutineModules?.[row.type],
      routine: { ...rest, id: row?.routineId },
      preview: true,
    });
  };
  return (
    <>
      <RoutineFold
        maxHeight={maxHeight}
        onRoutineSelected={onRoutineSelected}
      />

      {openRoutinePreviewModal && executeModalProps && (
        <RoutinePreviewModal
          executeModalProps={executeModalProps}
          openRoutinePreviewModal={openRoutinePreviewModal}
          setOpenRoutinePreviewModal={setOpenRoutinePreviewModal}
          setExecuteModalProps={setExecuteModalProps}
        />
      )}
    </>
  );
};
